import { createRef } from 'react';

import { useDidMount } from '@hsp/react-hooks';

import { useSidebarStore } from 'store/sidebar';

export const useVerticalLayoutConfiguration = () => {
  const open = useSidebarStore((state) => state.open);

  const ref = createRef<HTMLDivElement>();

  useDidMount(() => window.scrollTo(0, 0));

  return { open, ref };
};
